import {getAddressInput} from './get-address-input';
import {getDatePicker} from './get-date-picker';
import {getDynamicSection} from './get-dynamic-section';
import {getFileSelect} from './get-file-select';
import {getInput} from './get-input';
import {getInputButton} from './get-input-button';
import {getMultiSelect} from './get-multi-select';
import {getSection} from './get-section';
import {getSelect} from './get-select';
import {getTextArea} from './get-text-area';
import {getTimePicker} from './get-time-picker';
import {getSwitch} from './get-switch';
import {getAsyncSelect} from './get-async-select';
import {getNumberInput} from './get-number-input';
import {getAudioRecorder} from './get-audio-recorder';
import {getListSection} from './get-list-section';
import {getVideoInput} from './get-video-input';
import {getAsyncMultiSelect} from './get-async-multi-select';
import {getTextSection} from './get-text-section';
import {getInlineCode} from './get-inline-code';
import {getImagePicker} from './get-image-picker';
import { getCustomInput } from './get-custom-input';
import { getPriceInput } from './get-price-input';
import { getDynamicTable } from './get-dynamic-table';

const useFormInputs = <T = any, D = any>() => {
  return {
    getAddressInput: getAddressInput<T>,
    getDatePicker: getDatePicker<T>,
    getDynamicSection: getDynamicSection<T, D>,
    getFileSelect: getFileSelect<T>,
    getInputButton: getInputButton<T>,
    getInput: getInput<T>,
    getMultiSelect: getMultiSelect<T>,
    getSection: getSection<T>,
    getSelect: getSelect<T>,
    getTextArea: getTextArea<T>,
    getTimePicker: getTimePicker<T>,
    getSwitch: getSwitch<T>,
    getAsyncSelect: getAsyncSelect<T>,
    getNumberInput: getNumberInput<T>,
    getAudioRecorder: getAudioRecorder<T>,
    getListSection: getListSection<T>,
    getVideoInput: getVideoInput,
    getAsyncMultiSelect: getAsyncMultiSelect<T>,
    getTextSection: getTextSection<T>,
    getInlineCode: getInlineCode<T>,
    getImagePicker: getImagePicker<T>,
    getCustomInput: getCustomInput<T>,
    getPriceInput: getPriceInput<T>,
    getDynamicTable: getDynamicTable<T>
  };
};

export default useFormInputs;
